import TimeLimit from '@svenskaspelab/ui/react/icons/TimeLimit';

import type { DialogConfig } from '../../../types.js';

const dialogContent = {
  icon: <TimeLimit />,
  title: 'Tidsgräns uppnådd',
  description:
    'Du har uppnått din dagliga tidsgräns. När du har nått din tidsgräns kan du inte betala spel eller sätta in pengar.',
};

export function dayTimeLimitEndDialog(onAcknowledge: () => void, onLogout: () => void): DialogConfig {
  return {
    ...dialogContent,
    buttons: {
      primary: {
        label: 'Okej',
        action: () => {
          void onAcknowledge();
        },
      },
      secondary: {
        label: 'Logga ut',
        action: () => {
          void onLogout();
        },
      },
    },
  };
}

export function dayTimeLimitAckDialog(onAcknowledge = () => {}): DialogConfig {
  return {
    ...dialogContent,
    buttons: {
      primary: {
        label: 'Okej',
        action: () => {
          void onAcknowledge();
        },
      },
    },
  };
}
